exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".modal-email {\n  display: -ms-flexbox;\n  display: flex;\n  height: calc(100% - 77px); }\n  .modal-email .email-wrapper {\n    -webkit-transform: translateY(-54px);\n    -ms-transform: translateY(-54px);\n    transform: translateY(-54px);\n    width: 100%;\n    margin: auto;\n    padding: 0 16px; }\n    .modal-email .email-wrapper .button {\n      margin-top: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/Email/styles.scss
// module id = 1272
// module chunks = 0